import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, Check } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { useScreenInit } from '../../useScreenInit';
export function Terms() {
  useScreenInit();
  const navigate = useNavigate();
  const [accepted, setAccepted] = useState(false);
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-207">
      <header className="px-4 py-4 flex items-center border-b border-gray-100 sticky top-0 bg-white z-10" data-id="element-208">
        <button onClick={() => navigate(-1)} className="p-2 -ml-2 text-text-secondary hover:text-text-primary" data-id="element-209">
          <ChevronLeft className="w-6 h-6" data-id="element-210" />
        </button>
        <h1 className="text-lg font-bold text-text-primary ml-2" data-id="element-211">
          Terms & Conditions
        </h1>
      </header>

      <main className="flex-1 px-6 py-6 overflow-y-auto" data-id="element-212">
        <h2 className="text-2xl font-heading font-bold text-text-primary mb-6" data-id="element-213">
          Digital Consent Agreement
        </h2>

        <div className="prose prose-sm text-text-secondary space-y-4" data-id="element-214">
          <p data-id="element-215">
            Welcome to FortuneBridge. By proceeding, you agree to the following
            terms regarding your participation in our platform.
          </p>

          <h3 className="text-text-primary font-bold text-base mt-6" data-id="element-216">
            1. Data Collection & Privacy
          </h3>
          <p data-id="element-217">
            We collect personal, business, and location data to verify your
            identity and match you with sponsors. Your data is stored securely
            and only shared with verified sponsors and field agents assigned to
            you.
          </p>

          <h3 className="text-text-primary font-bold text-base mt-6" data-id="element-218">
            2. Verification Process
          </h3>
          <p data-id="element-219">
            You agree to provide accurate information. Field agents may visit
            your business location to verify the details provided. False
            information may lead to account suspension.
          </p>

          <h3 className="text-text-primary font-bold text-base mt-6" data-id="element-220">
            3. Funding & Support
          </h3>
          <p data-id="element-221">
            Funding is not guaranteed and depends on sponsor matching. Funds
            must be used strictly for the business purposes stated in your
            application.
          </p>

          <h3 className="text-text-primary font-bold text-base mt-6" data-id="element-222">
            4. Monitoring & Reporting
          </h3>
          <p data-id="element-223">
            If funded, you agree to participate in regular monitoring, provide
            progress updates, and allow field agents to document your business
            growth.
          </p>
        </div>
      </main>

      <div className="p-6 bg-white border-t border-gray-100 shadow-[0_-4px_20px_-10px_rgba(0,0,0,0.05)]" data-id="element-224">
        <label className="flex items-start mb-6 cursor-pointer group" data-id="element-225">
          <div className="relative flex items-center justify-center mt-0.5 mr-3" data-id="element-226">
            <input type="checkbox" className="sr-only" checked={accepted} onChange={() => setAccepted(!accepted)} data-id="element-227" />
            <div className={`w-6 h-6 rounded-lg border-2 flex items-center justify-center transition-colors ${accepted ? 'bg-brand-primary border-brand-primary' : 'border-gray-300 group-hover:border-brand-primary'}`} data-id="element-228">
              {accepted && <Check className="w-4 h-4 text-white" data-id="element-229" />}
            </div>
          </div>
          <span className="text-sm text-text-primary font-medium leading-tight" data-id="element-230">
            I have read and agree to the Terms & Conditions and Privacy Policy.
          </span>
        </label>

        <Button fullWidth size="lg" disabled={!accepted} onClick={() => navigate('/onboarding')} data-id="element-231">
          Accept & Continue
        </Button>
      </div>
    </div>;
}